//最好放在最上面
import 'babel-polyfill';
import 'core-js/stable';
// 必须放在所有代码之前！
import 'regenerator-runtime/runtime'
require('es6-promise').polyfill()
// Es6Promise.polyfill()

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/styles/fonts.scss'; // 基础配置
import '@/styles/local-fonts.scss'; // 可选字体文件

// import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/scss/element-variables.scss'



import VueRouter from 'vue-router';
Vue.use(VueRouter);


const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
}


Vue.config.productionTip = false
import ELImageViewer from "element-ui/packages/image/src/image-viewer.vue";
Vue.component('el-image-viewer', ELImageViewer);

/**图片方法【主要是为了在小程序使用线上图片，其他使用本地图片】*/
import imgs from "@/utils/my.js"
Vue.prototype.$imgs = imgs;

import * as constants  from "@/utils/constants";
// 挂载到 Vue 原型，以 $ 开头避免命名冲突
Vue.prototype.$constants = constants; 

import VueScrollPicker from "vue-scroll-picker"
import "vue-scroll-picker/dist/style.css"
Vue.use(VueScrollPicker)

import VueClamp from 'vue-clamp';
Vue.component('vue-clamp', VueClamp);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
